interface ICommunityStatsProps {
  businessOverallStats: BusinessOverallStatsType | null;
}

const CommunityStats: React.FC<ICommunityStatsProps> = ({
  businessOverallStats: feedback,
}) => {
  const highlightedText = "md:text-5xl text-3xl font-semibold";
  return (
    <div className="bg-brightPurple border-2  w-full h-full border-brightPurple border-opacity-5 gap-4 flex flex-col rounded-lg md:min-w-full min-w-[85vw]">
      <p className="text-black md:text-2xl text-xl  tracking-wider md:!leading-[54px] leading-loose">
        <span className="md:text-5xl text-3xl">{">"}</span>
        <span className={highlightedText}>{`${
          feedback?.totalUsersCount || 0
        }`}</span>
         local shoppers on Open Rewards have spent
        <span className={highlightedText}>
           ${feedback?.totalAmountSpent || 0}{" "}
        </span>
         {"at "}
        <span className={highlightedText}>
          {feedback?.totalBusinessesCount}{" "}
        </span>
        local businesses, like yours!
      </p>
    </div>
  );
};

export default CommunityStats;
